import React, { useState, useEffect } from "react";
import Footer from "../Components/Footer";
import Header from "../Components/Header";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2 , Camera, Play, MapPin, ChevronLeft, ChevronRight} from 'lucide-react';
import Sidebar from '../Components/Sidebar'
import PremiumNavbar from "../Components/PremiumNavbar";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function YachtDetails() {
const [yachtMediaTab, setYachtMediaTab] = useState('photos');
  const [yachtGalleryIndex, setYachtGalleryIndex] = useState(0);

  const yachtPhotoLibrary = [
    "https://images.unsplash.com/photo-1569263979104-865ab7cd8d13?auto=format&fit=crop&q=80&w=1200",
    "https://images.unsplash.com/photo-1540962351504-03099e0a754b?auto=format&fit=crop&q=80&w=1200",
    "https://images.unsplash.com/photo-1621275471769-e6aa344546d5?auto=format&fit=crop&q=80&w=1200",
    "https://images.unsplash.com/photo-1569263979104-865ab7cd8d13?auto=format&fit=crop&q=80&w=1200"
  ];

 

  const CMS_API_URL = "";
  const navigate = useNavigate();
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const tripQuery = searchParams.get("trip");

  const [activeTab, setActiveTab] = useState("description");
  const [boatdetails, setBoatdetails] = useState(null);
  const [timeSlots, setTimeSlots] = useState([]);
 const [selectedSlots, setSelectedSlots] = useState([]);

  const [selectedDate, setSelectedDate] = useState("");
  const [tripType, setTripType] = useState("one-way");
  const [fromHour, setFromHour] = useState("");
  const [toHour, setToHour] = useState("");
  const [quotedPrice, setQuotedPrice] = useState(null);
  const [quoteDuration, setQuoteDuration] = useState(null);

  const padHour = (hour) => `${String(Number(hour)).padStart(2, "0")}:00`;
  const hourOptionLabel = (hour) => {
    const value = Number(hour);
    const suffix =
      value === 0
        ? "12 AM"
        : value < 12
          ? `${value} AM`
          : value === 12
            ? "12 PM"
            : `${value - 12} PM`;
    return `${padHour(value)} (${suffix})`;
  };
  const HOURS_24 = Array.from({ length: 24 }, (_, index) => index);

  const getMediaUrl = (path) => {
    if (!path) {
      return "";
    }
    if (path.startsWith("http")) {
      return path;
    }
    if (path.startsWith("/uploads/")) {
      return `${CMS_API_URL}${path}`;
    }
    if (path.startsWith("assets/")) {
      return `/${path}`;
    }
    return path;
  };

  const toEmbedUrl = (url) => {
    if (!url) {
      return "";
    }
    if (url.includes("embed/")) {
      return url;
    }
    const match = url.match(/(?:v=|youtu\.be\/)([\w-]+)/);
    if (match) {
      return `https://www.youtube.com/embed/${match[1]}`;
    }
    return url;
  };

  useEffect(() => {
    let cancelled = false;

    const loadYachtDetails = async () => {
      setBoatdetails(null);
      setTimeSlots([]);
      setSelectedSlots([]);
      setFromHour("");
      setToHour("");
      setQuotedPrice(null);
      setQuoteDuration(null);
      setYachtGalleryIndex(0);

      try {
        const response = await fetch(`${CMS_API_URL}/api/yacht-details/${id}`);

        if (response.ok) {
          const result = await response.json();
          if (cancelled) {
            return;
          }
          setBoatdetails(result);

          if (result.pageKey === "SpeedBoat") {
            const ratesResponse = await fetch(
              `${CMS_API_URL}/api/speedboat-rates/boat/${id}`
            );
            const rate = ratesResponse.ok ? await ratesResponse.json() : null;
            if (cancelled) {
              return;
            }

            setTimeSlots(
              (rate?.oneWaySlots || []).map((slot) => ({
                id: `ow-${slot.hour}`,
                hour: slot.hour,
                time: padHour(slot.hour),
                price: Number(slot.price) || 0,
                discount: 0,
              }))
            );

            const canOne = result.inMumbai === true;
            const canTwo = result.inGoa === true;
            let nextTrip = "one-way";
            if (tripQuery === "two-way" && canTwo) {
              nextTrip = "two-way";
            } else if (tripQuery === "one-way" && canOne) {
              nextTrip = "one-way";
            } else if (canOne) {
              nextTrip = "one-way";
            } else if (canTwo) {
              nextTrip = "two-way";
            }
            setTripType(nextTrip);
            return;
          }

          const pricesResponse = await fetch(
            `${CMS_API_URL}/api/yacht-prices/boat/${id}`
          );
          const prices = pricesResponse.ok ? await pricesResponse.json() : [];
          if (!cancelled) {
            setTimeSlots(Array.isArray(prices) ? prices : []);
          }
          return;
        }

        const fallback = await fetch(`${CMS_API_URL}/api/experiences`);
        const pages = fallback.ok ? await fallback.json() : [];
        const match = (Array.isArray(pages) ? pages : [])
          .flatMap((page) => [
            ...(page.luxuryMumbai || []),
            ...(page.exploreMumbai || []),
            ...(page.luxuryGoa || []),
            ...(page.exploreGoa || []),
            ...(page.corporateCards || []),
          ])
          .find((card) => String(card._id) === String(id));

        if (cancelled) {
          return;
        }

        if (!match) {
          throw new Error("Boat not found");
        }

        setBoatdetails({
          cardId: match._id,
          boatName: match.title || match.category || "Yacht",
          yachtType: match.category || match.type || "",
          locationName: "",
          placeName: "",
          capacity: match.capacity || "",
          hullType: match.type || "",
          length: match.dimensions || "",
          description: match.desc || "",
          specifications: "",
          amenities: "",
          photos: match.imgUrl ? [match.imgUrl] : [],
          videoUrl: "",
          mapUrl: "",
          timeGroupIds: [],
        });
        setTimeSlots([]);
      } catch (error) {
        console.error(error);
        if (!cancelled) {
          setBoatdetails({
            boatName: "Yacht details could not be loaded",
            yachtType: "",
            locationName: "",
            photos: [],
            timeGroupIds: [],
          });
          setTimeSlots([]);
        }
      }
    };

    if (id) {
      loadYachtDetails();
    }

    return () => {
      cancelled = true;
    };
  }, [id, tripQuery]);

  useEffect(() => {
    if (boatdetails?.pageKey !== "SpeedBoat" || tripType !== "two-way") {
      setQuotedPrice(null);
      setQuoteDuration(null);
      return undefined;
    }

    if (
      fromHour === "" ||
      toHour === "" ||
      Number(fromHour) === Number(toHour)
    ) {
      setQuotedPrice(null);
      setQuoteDuration(null);
      return undefined;
    }

    let cancelled = false;

    const loadQuote = async () => {
      try {
        const response = await fetch(`${CMS_API_URL}/api/speedboat-rates/quote`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            cardId: id,
            tripType: "two-way",
            fromHour: Number(fromHour),
            toHour: Number(toHour),
          }),
        });
        const result = await response.json();
        if (cancelled) {
          return;
        }
        if (!response.ok) {
          setQuotedPrice(null);
          setQuoteDuration(null);
          return;
        }
        setQuotedPrice(Number(result.price) || 0);
        setQuoteDuration(result.duration);
      } catch (error) {
        console.error(error);
        if (!cancelled) {
          setQuotedPrice(null);
          setQuoteDuration(null);
        }
      }
    };

    loadQuote();
    return () => {
      cancelled = true;
    };
  }, [id, boatdetails?.pageKey, tripType, fromHour, toHour]);

  if (!boatdetails) {
    return (
      <div style={{ padding: 50 }}>
        Loading yacht details... If this stays here, go back and open Book Now
        after the boats have loaded, or check that the backend is running on
        port 5000.
      </div>
    );
  }
const getSlotKey = (slot) => slot.id || slot.time;

const handleSlotClick = (slot) => {
  if (boatdetails?.pageKey === "SpeedBoat") {
    const exists = selectedSlots.find(
      (item) => getSlotKey(item) === getSlotKey(slot)
    );
    setSelectedSlots(exists ? [] : [slot]);
    return;
  }

  const exists = selectedSlots.find(
    (item) => getSlotKey(item) === getSlotKey(slot)
  );

  if (exists) {
    setSelectedSlots((prev) =>
      prev.filter((item) => getSlotKey(item) !== getSlotKey(slot))
    );
  } else {
    setSelectedSlots((prev) => [...prev, slot]);
  }
};

  const photos =
    Array.isArray(boatdetails?.photos) && boatdetails.photos.length > 0
      ? boatdetails.photos.map(getMediaUrl)
      : yachtPhotoLibrary;

  const imageUrl = photos[0];
  const isSpeedBoat = boatdetails?.pageKey === "SpeedBoat";
  const tripLabel = tripType === "two-way" ? "Two Way" : "One Way";

  const handleNextYachtSlide = () =>
    setYachtGalleryIndex((prev) =>
      prev === photos.length - 1 ? 0 : prev + 1
    );
  const handlePrevYachtSlide = () =>
    setYachtGalleryIndex((prev) =>
      prev === 0 ? photos.length - 1 : prev - 1
    );

    const handleAddToCart = () => {
      const isSpeedBoat = boatdetails?.pageKey === "SpeedBoat";
      const tripLabel = tripType === "two-way" ? "Two Way" : "One Way";
    
      if (!selectedDate) {
        alert("Please select date");
        return;
      }
    
      let existingCart = JSON.parse(localStorage.getItem("cart")) || [];
    
      if (!Array.isArray(existingCart)) {
        existingCart = [];
      }
    
      if (isSpeedBoat && tripType === "two-way") {
        if (
          fromHour === "" ||
          toHour === "" ||
          Number(fromHour) === Number(toHour)
        ) {
          alert("Please select from and to times");
          return;
        }
        if (quotedPrice === null) {
          alert("Price is not available for this time range");
          return;
        }
    
        const cartItem = {
          id: boatdetails?.cardId || id,
          boatName: boatdetails?.boatName,
          image: imageUrl,
          date: selectedDate,
          time: `${padHour(fromHour)} - ${padHour(toHour)}`,
          location: tripLabel,
          price: quotedPrice,
        };
    
        const alreadyExists = existingCart.some(
          (item) =>
            item.id === cartItem.id &&
            item.date === cartItem.date &&
            item.time === cartItem.time
        );
    
        if (alreadyExists) {
          alert("This booking already existed");
          return;
        }
    
        existingCart.push(cartItem);
        localStorage.setItem("cart", JSON.stringify(existingCart));
    
        // Updated navigation target
        navigate("/addons");
        return;
      }
    
      if (selectedSlots.length === 0) {
        alert("Please select time");
        return;
      }
    
      let addedCount = 0;
      let duplicateCount = 0;
    
      selectedSlots.forEach((slot) => {
        const finalPrice =
          slot.discount > 0
            ? slot.price - (slot.price * slot.discount) / 100
            : slot.price;
    
        const cartItem = {
          id: boatdetails?.cardId || id,
          boatName: boatdetails?.boatName,
          image: imageUrl,
          date: selectedDate,
          time: slot.time,
          location: isSpeedBoat
            ? tripLabel
            : boatdetails?.placeName || boatdetails?.locationName,
          price: finalPrice,
        };
    
        const alreadyExists = existingCart.some(
          (item) =>
            item.id === cartItem.id &&
            item.date === cartItem.date &&
            item.time === cartItem.time
        );
    
        if (alreadyExists) {
          duplicateCount++;
        } else {
          existingCart.push(cartItem);
          addedCount++;
        }
      });
    
      localStorage.setItem("cart", JSON.stringify(existingCart));
    
      if (duplicateCount > 0 && addedCount === 0) {
        alert("Selected slot(s) are already in your cart");
        return;
      }
    
      // Updated navigation target
      navigate("/addons");
    };

  

  return (
    <>
      {/* <Header />  */}
      <PremiumNavbar /> 

      <section className="indiaboat-inner-page" id="yachtdetails_main">
        <div className="indiaboat-container">

          {/* ✅ Title */}
          <div className="indiaboat-hero-heading">
            <h1 className="indiaboat-main-title">
              {boatdetails?.boatName}
            </h1>
            <p className="indiaboat-subtitle">
              {isSpeedBoat
                ? `${boatdetails?.yachtType || "Speed Boat"} - ${tripLabel}`
                : `${boatdetails?.yachtType} - ${boatdetails?.locationName}`}
            </p>
          </div>

          {/* ✅ Gallery + Booking */}
          <div className="indiaboat-gallery-wrapper">

            {/* LEFT : IMAGE SLIDER */}
            <div className="indiaboat-slider-alpha">

              <div className="vlt-media-container">
      {/* Tab Navigation */}
      <div className="vlt-media-tabs">
        <button 
          className={`vlt-tab-btn ${yachtMediaTab === 'photos' ? 'active' : ''}`}
          onClick={() => setYachtMediaTab('photos')}
        >
          <Camera size={16} />
          PHOTOS
        </button>
        <button 
          className={`vlt-tab-btn ${yachtMediaTab === 'video' ? 'active' : ''}`}
          onClick={() => setYachtMediaTab('video')}
        >
          <Play size={16} />
          VIDEO
        </button>
        <button 
          className={`vlt-tab-btn ${yachtMediaTab === 'map' ? 'active' : ''}`}
          onClick={() => setYachtMediaTab('map')}
        >
          <MapPin size={16} />
          MAP
        </button>
      </div>

      {/* Content Area */}
      <div className="vlt-media-viewport">
        {yachtMediaTab === 'photos' && (
          <div className="vlt-slider-container">
            <div 
              className="vlt-slider-track" 
              style={{ transform: `translateX(-${yachtGalleryIndex * 100}%)` }}
            >
              {photos.map((url, idx) => (
                <div key={idx} className="vlt-slide">
                  <img src={url} alt={`Yacht view ${idx + 1}`} />
                </div>
              ))}
            </div>
            
            {/* Slider Controls */}
            <button className="vlt-slider-nav prev" onClick={handlePrevYachtSlide}>
              <ChevronLeft size={24} />
            </button>
            <button className="vlt-slider-nav next" onClick={handleNextYachtSlide}>
              <ChevronRight size={24} />
            </button>

            {/* Pagination Dots */}
            <div className="vlt-slider-dots">
              {photos.map((_, idx) => (
                <span 
                  key={idx} 
                  className={`vlt-dot ${yachtGalleryIndex === idx ? 'active' : ''}`}
                  onClick={() => setYachtGalleryIndex(idx)}
                />
              ))}
            </div>
          </div>
        )}

        {yachtMediaTab === 'video' && (
          <div className="vlt-video-wrapper">
            <iframe 
              width="100%" 
              height="100%" 
              src={toEmbedUrl(boatdetails?.videoUrl) || "https://www.youtube.com/embed/XhtzBigoL34"} 
              title="Yacht Experience Video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
              allowFullScreen
            ></iframe>
          </div>
        )}

        {yachtMediaTab === 'map' && (
          <div className="vlt-map-wrapper">
            <iframe title={boatdetails?.locationName}
              src={boatdetails?.mapUrl || "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3774.2057398188044!2d72.83204917604586!3d18.92198915680155!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7d1c06aba07bb%3A0x691efed3f81e7d8!2sGateway%20Of%20India%20Mumbai!5e0!5m2!1sen!2sin"} 
              width="100%" 
              height="100%" 
              style={{ border: 0 }} 
              allowFullScreen="" 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
            <div className="vlt-map-float-card">
               <strong>Pickup Point</strong>
               <p>{boatdetails?.locationName}</p>
            </div>
          </div>
        )}
      </div>
              </div>
             
            </div>

            {/* RIGHT : BOOKING BOX */}
            <div className="yacht-booking-card-alpha">
              <div className="yacht_det_title">
                {/* <h3 className="yacht-booking-title-alpha">
                {boatdetails?.yachtType}
              </h3> */}
 <label className="vlt-ds-main-label">
                  {isSpeedBoat
                    ? tripType === "two-way"
                      ? "Select from and to time"
                      : "Select time"
                    : "Select Multipal Time Slot"}
                </label>
              </div>
               

              <div className="yacht-booking-time-alpha">
     

      <div className="time-slot-wrapper">
        {isSpeedBoat && tripType === "two-way" ? (
          <>
            <div className="yb-time-item-alpha" style={{ width: "100%" }}>
              <label className="vlt-ds-main-label">From</label>
              <select
                className="vlt-ds-date-field"
                value={fromHour}
                onChange={(e) => setFromHour(e.target.value)}
              >
                <option value="">Select</option>
                {HOURS_24.map((hour) => (
                  <option key={`from-${hour}`} value={hour}>
                    {hourOptionLabel(hour)}
                  </option>
                ))}
              </select>
            </div>
            <div className="yb-time-item-alpha" style={{ width: "100%" }}>
              <label className="vlt-ds-main-label">To</label>
              <select
                className="vlt-ds-date-field"
                value={toHour}
                onChange={(e) => setToHour(e.target.value)}
              >
                <option value="">Select</option>
                {HOURS_24.map((hour) => (
                  <option key={`to-${hour}`} value={hour}>
                    {hourOptionLabel(hour)}
                  </option>
                ))}
              </select>
            </div>
            {quoteDuration ? (
              <p className="yacht-booking-price-alpha">
                {quoteDuration} hour{quoteDuration === 1 ? "" : "s"}
                {quotedPrice !== null
                  ? ` • ₹${Number(quotedPrice).toLocaleString("en-IN")}`
                  : ""}
              </p>
            ) : fromHour !== "" &&
              toHour !== "" &&
              Number(fromHour) === Number(toHour) ? (
              <p className="yacht-booking-price-alpha">
                From and to times must be different
              </p>
            ) : null}
          </>
        ) : (
        timeSlots.map((slot, index) => {
          const isSelected = selectedSlots.some(
            (item) => getSlotKey(item) === getSlotKey(slot)
          );
          const hasDiscount = slot.discount > 0;
          const finalPrice = hasDiscount
            ? slot.price - (slot.price * slot.discount) / 100
            : slot.price;

          return (
            <div
              key={index}
              className={`time-slot-box ${isSelected ? "selected" : ""} ${hasDiscount ? "vlt-ds-has-promo" : ""}`}
              onClick={() => handleSlotClick(slot)}
            >
              {/* {hasDiscount && (
                <div className="vlt-ds-promo-pill">
                  <Tag size={10} />
                  {slot.discount}% OFF
                </div>
              )} */}
              
              <div className="vlt-ds-slot-info">
                <p className="time">{slot.time}</p>
                <div className="vlt-ds-price-row">
                  <p className="price">₹{finalPrice.toLocaleString('en-IN')}</p>
                  {hasDiscount && (
                    <span className="vlt-ds-strike">₹{slot.price.toLocaleString('en-IN')}</span>
                  )}
                </div>
              </div>

              {isSelected && <CheckCircle2 size={16} className="vlt-ds-indicator" />}
            </div>
          );
        })
        )}
      </div>

      <div className="date_capacity">
        <div className="yb-time-item-alpha">
        <label className="vlt-ds-main-label">Date</label>
        <div className="vlt-ds-input-container">
          {/* <input
  type="date"
  className="vlt-ds-date-field"
  value={selectedDate}
  min={new Date().toISOString().split("T")[0]}  
  onChange={(e) => {
  setSelectedDate(e.target.value);
}}
/> */}

<DatePicker
      selected={selectedDate}
      onChange={(date) => setSelectedDate(date)}
      minDate={new Date()}
      dateFormat="dd/MM/yyyy"
      placeholderText="DD/MM/YYYY"
      className="vlt-ds-date-field"
    />

        </div>

       
      </div>
       <p className="yacht-booking-price-alpha">
                  Capacity: {boatdetails?.capacity}
                </p>
      </div>
      </div>

              <div className="yacht-booking-footer-alpha">
                <p className="yacht-booking-location-alpha">
                  {isSpeedBoat
                    ? tripLabel
                    : boatdetails?.placeName || boatdetails?.locationName}
                </p>

                
              </div>

              <button
                className="th-btn style3 th-icon" id="book_now"
                onClick={handleAddToCart}
              >
                Book Now
              </button>


            <Sidebar/>
            </div>

          </div>

          {/* ✅ Tabs */}
          {/* <div className="indiaboat-details-wrap">

            <div className="indiaboat-details-tabs">
              <button
                className={`indiaboat-tab-btn ${
                  activeTab === "description" ? "active" : ""
                }`}
                onClick={() => setActiveTab("description")}
              >
                Description
              </button>

              <button
                className={`indiaboat-tab-btn ${
                  activeTab === "specifications" ? "active" : ""
                }`}
                onClick={() => setActiveTab("specifications")}
              >
                Specifications
              </button>

              <button
                className={`indiaboat-tab-btn ${
                  activeTab === "amenities" ? "active" : ""
                }`}
                onClick={() => setActiveTab("amenities")}
              >
                Amenities
              </button>
            </div>

           
            {activeTab === "description" && (
              <div className="indiaboat-tab-content">
                <div className="yacht-spec-container">

                  <div className="yacht-spec-row">
                    <div className="yacht-spec-key">YACHT NAME:</div>
                    <div className="yacht-spec-value">
                      {boatdetails?.boatName}
                    </div>
                  </div>

                  <div className="yacht-spec-row">
                    <div className="yacht-spec-key">YACHT LENGTH:</div>
                    <div className="yacht-spec-value">
                      {boatdetails?.length}
                    </div>
                  </div>

                  <div className="yacht-spec-row">
                    <div className="yacht-spec-key">TYPE OF HULL:</div>
                    <div className="yacht-spec-value">
                      {boatdetails?.hullType}
                    </div>
                  </div>

                  {boatdetails?.description ? (
                    <p style={{ marginTop: 16, whiteSpace: "pre-wrap" }}>
                      {boatdetails.description}
                    </p>
                  ) : null}

                </div>
              </div>
            )}

           
            {activeTab === "specifications" && (
              <div className="indiaboat-tab-content">
                <div style={{ whiteSpace: "pre-wrap" }}>
                  {boatdetails?.specifications || ""}
                </div>
              </div>
            )}

           
            {activeTab === "amenities" && (
              <div className="indiaboat-tab-content">
                <div style={{ whiteSpace: "pre-wrap" }}>
                  {boatdetails?.amenities || ""}
                </div>
              </div>
            )}

            <button
              className="yacht-booking-btn-alpha"
              onClick={handleAddToCart}
            >
              Book Now
            </button>

          </div> */}

         
          <div className="indiaboat-cta">
            <h2 className="indiaboat-cta-title">
              Ready to Plan Your Voyage?
            </h2>

            <p className="indiaboat-cta-text">
              Contact us today for your dream charter.
            </p>

            <a href="/contact" className="indiaboat-cta-btn">
              Enquire & Book
            </a>
          </div>

        </div>
      </section>

      <Footer />
    </>
  );
}
